import { useState } from 'react';
import { useForm } from '../../hooks/useForm';

import ErrorMessage from './ErrorMessage';
import SubmitButton from './SubmitButton';
import SuccessMessage from './SuccessMessage';
import TextInput from './TextInput';

const ContactForm = ({ title, titleSize, buttonText }) => {
    const TitleTag = `h${titleSize}`;
    const [apiError, setApiError] = useState(null);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting, isSubmitSuccessful }
    } = useForm({ defaultValues: { name: '', email: '', organization: '', message: '' } });

    const onSubmit = async data => {
        setApiError(null);
        try {
            const res = await fetch('/api/forms/contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });

            const json = await res.json();

            if (!json.success) {
                throw new Error(json.message || 'Noe gikk galt, prøv igjen senere');
            }

            reset();
            return json;
        } catch (err) {
            setApiError(err.message);
            throw err;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="contact-form-wrapper">
            {title && <TitleTag>{title}</TitleTag>}

            <TextInput
                label="Navn*"
                name="name"
                type="text"
                autocomplete="name"
                error={errors.name}
                disableTab={isSubmitSuccessful}
                {...register('name', {
                    required: 'Navn er påkrevd.',
                    minLength: { value: 2, message: 'For kort.' }
                })}
            />

            <TextInput
                label="E-post*"
                name="email"
                type="email"
                autocomplete="email"
                error={errors.email}
                disableTab={isSubmitSuccessful}
                {...register('email', {
                    required: 'E-post er påkrevd.',
                    pattern: { value: /\S+@\S+\.\S+/, message: 'Ugyldig e-post.' }
                })}
            />

            <TextInput
                label="Organisasjon"
                name="organization"
                type="text"
                autocomplete="organization"
                error={errors.organization}
                disableTab={isSubmitSuccessful}
                {...register('organization', {
                    maxLength: { value: 100, message: 'For langt.' }
                })}
            />

            <TextInput
                label="Melding*"
                name="message"
                type="textarea"
                as="textarea"
                error={errors.message}
                disableTab={isSubmitSuccessful}
                {...register('message', {
                    required: 'Melding er påkrevd.',
                    minLength: { value: 2, message: 'For kort.' }
                })}
            />

            <div className="form-submit-row">
                <SubmitButton isLoading={isSubmitting} disableTab={isSubmitSuccessful}>
                    {buttonText || 'Send melding'}
                </SubmitButton>
                {apiError && <ErrorMessage message={apiError} />}
                {isSubmitSuccessful && <SuccessMessage message="Meldingen ble sendt!" />}
            </div>
        </form>
    );
};

export default ContactForm;
